import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    //const location = useLocation();

    useEffect(() => {
        // Scroll to the top when location changes
        window.scrollTo(0, 0);
    }, []);

    return null;
};

export default ScrollToTop;
